import { render, staticRenderFns } from "./InventoryAuto.vue?vue&type=template&id=6cfb9061&scoped=true&"
import script from "./InventoryAuto.vue?vue&type=script&lang=js&"
export * from "./InventoryAuto.vue?vue&type=script&lang=js&"
import style0 from "./InventoryAuto.vue?vue&type=style&index=0&id=6cfb9061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfb9061",
  null
  
)

export default component.exports